export default "__VITE_ASSET__BxcyZsqu__"